var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTienda24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0089 14.8373C10.7219 14.8373 9.67394 15.8946 9.67394 17.2083V20.5119H14.3535V17.2083C14.3535 15.9014 13.3123 14.8373 12.0186 14.8373H12.0089ZM8.20851 17.2083C8.20851 15.0697 9.91559 13.3492 12.0089 13.3492H12.0186C14.1247 13.3492 15.819 15.0827 15.819 17.2083V22H8.20851V17.2083Z",
    fill: "#88919E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43748 10.1746V18.3591C4.43748 19.5454 5.38924 20.5119 6.55746 20.5119H17.47C18.6383 20.5119 19.59 19.5454 19.59 18.3591V10.1746H21.0554V18.3591C21.0554 20.3673 19.4476 22 17.47 22H6.55746C4.5799 22 2.97205 20.3673 2.97205 18.3591V10.1746H4.43748Z",
    fill: "#88919E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0186 11.752C9.78565 11.752 7.98382 9.90949 7.98382 7.65476H9.44924C9.44924 9.09051 10.5978 10.2639 12.0186 10.2639C13.4409 10.2639 14.588 9.09899 14.588 7.65476H16.0534C16.0534 9.92085 14.2502 11.752 12.0186 11.752Z",
    fill: "#88919E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.44364 5.18377C2.66775 3.36582 4.19531 2 6.0006 2H18.0171C19.8233 2 21.3515 3.36714 21.5744 5.18642L21.9013 6.85621C22.0457 7.60029 22.0576 8.43506 21.7597 9.22916C21.2166 10.6793 19.8939 11.752 18.3102 11.752C16.1897 11.752 14.5782 9.84186 14.5782 7.65476V3.4881H9.43947V7.65476C9.43947 9.85491 7.82525 11.752 5.69775 11.752C4.10211 11.752 2.79244 10.6774 2.2402 9.23369L2.23847 9.22917C1.94052 8.43495 1.9518 7.58855 2.10827 6.83794L2.44364 5.18377ZM7.97405 3.4881H6.0006C4.92545 3.4881 4.01848 4.30744 3.8953 5.38905L3.8916 5.42156L3.54317 7.14012L3.54227 7.14447C3.42583 7.70192 3.43719 8.24266 3.60708 8.69719C3.97361 9.65295 4.79311 10.2639 5.69775 10.2639C6.89188 10.2639 7.97405 9.16493 7.97405 7.65476V3.4881ZM16.0437 3.4881V7.65476C16.0437 9.15814 17.1286 10.2639 18.3102 10.2639C19.2078 10.2639 20.0343 9.6503 20.3901 8.69989C20.561 8.24434 20.5732 7.71005 20.4638 7.1451L20.4635 7.14379L20.1258 5.41905L20.1224 5.38905C19.9992 4.30744 19.0923 3.4881 18.0171 3.4881H16.0437Z",
    fill: "#88919E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTienda24X24);
export default __webpack_public_path__ + "static/media/TIENDA_24X24.3f15716d5724b2744d889005aa28c1e4.svg";
export { ForwardRef as ReactComponent };